// Typ i numer wizyty (decyzja 04.11): nazwa raportu = typ + numer, numer ma własne pole.

// Typ wizyty nie może kończyć się liczbą ("IMV 5", "IMV5"), bo numer wpisuje się obok
export const endsWithNumber = (text: string) => /\d\s*$/.test(text);

// Typ i numer z nazwy ("Remote IMV 12" → Remote IMV, 12), dla raportów bez zapisanego typu
export const splitVisitName = (name: string): { type: string; number: number | null } => {
  const m = name.trim().match(/^(.*\S)\s+(\d+)$/);
  return m ? { type: m[1], number: Number(m[2]) } : { type: name.trim(), number: null };
};

export const MAX_VISIT_NUMBER = 9999;

// Komunikat błędu albo null
export const validateVisit = (type: string, numberText: string): string | null => {
  if (!type.trim()) return "Wpisz typ wizyty.";
  if (endsWithNumber(type)) return "Typ wizyty nie może kończyć się liczbą. Numer wpisz w polu „Numer”.";
  if (numberText.trim() === "") return null;
  const n = Number(numberText);
  if (!Number.isInteger(n) || n < 1 || n > MAX_VISIT_NUMBER) return `Numer wizyty musi być liczbą od 1 do ${MAX_VISIT_NUMBER}.`;
  return null;
};
